module.exports = __webpack_public_path__ + "static/media/Promotion_Card_JP_Big.2f6ddcee.png";